import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type RangeFilter } from '../types/filters';

const DEFAULT_MIN_VALUATION = 0;
const DEFAULT_MAX_VALUATION = Number.MAX_SAFE_INTEGER;

export const valuationDefinition: FilterDefinition<RangeFilter> = {
  id: FilterId.VALUATION,
  name: 'Valuation',
  type: FilterType.RANGE,
  min: undefined,
  max: undefined,
  isActive: false,
  isVisible: true,
};

export const valuationHandler: FilterHandler<RangeFilter> = {
  isActive(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min !== undefined ||
      currentFilterState.max !== undefined
    );
  },
  isDefault(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min === undefined &&
      currentFilterState.max === undefined
    );
  },
  getEffectiveFilter(currentFilterState: RangeFilter) {
    return {
      ...currentFilterState,
      min: currentFilterState.min ?? DEFAULT_MIN_VALUATION,
      max: currentFilterState.max ?? DEFAULT_MAX_VALUATION,
    };
  },
};
